import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Dialog } from "primereact/dialog";
import MeaButton from "../../../../components/MeaButton";

const formatDecisionDateTime = (value) => {
  if (!value) {
    return "-";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "-";
  }
  return date.toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

const memberDisplayName = (member, fallbackId) => {
  if (!member && !fallbackId) {
    return "-";
  }
  if (member?.name) {
    return member.name;
  }
  const lastname = member?.lastname || "";
  const firstname = member?.firstname || "";
  const fullname = `${lastname} ${firstname}`.trim();
  if (fullname) {
    return fullname;
  }
  return fallbackId || "-";
};

const DecisionDetailsSlotChangeRequestModal = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false);
  const [request, setRequest] = useState(null);

  useImperativeHandle(ref, () => ({
    show: (item) => {
      setRequest(item);
      setVisible(true);
    },
  }));

  const isApproved = request?.status === "APPROVED";
  const isRejected = request?.status === "REJECTED";
  const title = isApproved
    ? "Détails d'approbation"
    : isRejected
      ? "Détails de refus"
      : "Détails de la demande";
  const decidedBy = isApproved
    ? memberDisplayName(request?.approved_by, request?.approved_by_id)
    : isRejected
      ? memberDisplayName(request?.rejected_by, request?.rejected_by_id)
      : "-";
  const decidedAt = isApproved ? request?.approved_at : isRejected ? request?.rejected_at : null;
  const createdBy = memberDisplayName(request?.created_by_member, request?.created_by_member_id);

  return (
    <Dialog
      header={title}
      visible={visible}
      style={{ width: "30vw" }}
      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      onHide={() => setVisible(false)}
      footer={
        <MeaButton
          label="Fermer"
          icon="pi pi-times"
          className="p-button-text"
          onClick={() => setVisible(false)}
        />
      }
    >
      <div className="flex flex-column gap-3">
        <div>
          <div className="text-500 text-sm">Créée par</div>
          <div className="font-medium">{createdBy}</div>
        </div>
        <div>
          <div className="text-500 text-sm">Traité par</div>
          <div className="font-medium">{decidedBy}</div>
        </div>
        <div>
          <div className="text-500 text-sm">Date et heure</div>
          <div className="font-medium">{formatDecisionDateTime(decidedAt)}</div>
        </div>
      </div>
    </Dialog>
  );
});

export default DecisionDetailsSlotChangeRequestModal;
